<template>
    <div class="position-box simulatedTrading setProfit" :class="{theme:theme}">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
            <div class="title">{{$t('langNew.szzyzs')}}</div>
        </div>
        <div class="cotainer">
          <div class="item-box1">
            <div class="item-head"><span class="title">{{item.currency}}</span><span class="buy" v-if="item.type == 1">{{$t('kxt.mr')}}</span><span class="buy" v-if="item.type == 2">{{$t('kxt.mc')}}</span><span> {{item.position_a}} {{$t('langNew.shou')}}</span><div class="cc">{{$t('hyjy.cc')}}</div></div>
            <ul class="ul-box">
              <li class="li">
                <div class="t1 price">USD<span v-show="item.profit_loss > 0">+</span>{{item.profit_loss | toFixed4}}</div>
                <div class="t2">{{$t('langNew.fdjyk')}}</div>
              </li>
              <li class="li">
                <div class="t1">{{item.open_price}}</div>
                <div class="t2">{{$t('hyjy.kcjg')}}</div>
              </li>
              <li class="li">
                <div class="t1">{{item.new_price}}</div>
                <div class="t2">{{$t('langNew.dqjg')}}</div>
              </li>
            </ul>
          </div>
          <div class="line"></div>
          <div class="gg-wrap">
          <ul class="num-wrap">
             <li class="num-li">
                <div>{{$t('zyzs.title')}}</div>
                <img class="img2" v-if="!isZy" @click="zyChange" src="@/assets/new/close-zyzs.png" alt="">
                <img class="img2" v-else @click="zyChange" src="@/assets/new/open-zyzs.png" alt="">
              </li>
              <li class="num-li">
                <div class="num-lt">
                  <div class="t1">{{$t('hyjy.zy')}}</div>
                  <div class="t2" v-show="currency_way == 1">>={{price}}</div>
                  <div class="t2" v-show="currency_way == 2"><={{price}}</div>
                </div>
                <div class="num-rt num-rt2">
                  <div class="num-box">
                    <img class="icon" src="@/assets/new/jian2-light.png" @click="numZy(-1)" alt="">
                    <input class="input" v-model="stop_profit" type="text" @keyup="keyMoneyZy" autocomplete="off">
                    <img class="icon" src="@/assets/new/jia2-light.png" @click="numZy(1)" alt="">
                  </div>
                </div>
              </li>
              <li class="num-li">
                <div class="num-lt">
                  <div class="t1">{{$t('hyjy.zs')}}</div>
                  <div class="t2" v-show="currency_way == 1"><={{price}}</div>
                  <div class="t2" v-show="currency_way == 2">>={{price}}</div>
                </div>
                <div class="num-rt num-rt2">
                  <div class="num-box">
                    <img class="icon" src="@/assets/new/jian2-light.png" @click="numZs(-1)" alt="">
                    <input class="input" v-model="stop_loss" type="text" @keyup="keyMoneyZs" autocomplete="off">
                    <img class="icon" src="@/assets/new/jia2-light.png" @click="numZs(1)" alt="">
                  </div>
                </div>
              </li>
          </ul>
          </div>
        </div>
        <div class="btn-box">
          <div class="btn-sell btn-bg" @click="sure">{{$t('hyjy.qr')}}</div>
        </div>
    </div>
</template>

<script>
let that = this;
export default {
    name: 'setProfit',
    data () {
        return {
          theme: false,
          item: {},
          id: '',
          currency: '',
          price: '',
          isZy: false,//开启止盈止损
          stop_profit: '',//止盈
          stop_loss: '',//	止损
          currency_way: 1,//方向
          count: 1
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      var item = JSON.parse(localStorage.getItem('szzyzsInfo'));
      this.item = item;
      this.id = item.id;
      this.currency = item.currency;
      this.price = item.price || '';
      this.currency_way = item.fx || 1;
    },
    mounted() {
      this.newprice = isNaN(this.newprice) ? 0 : this.newprice;
    },
    methods: {
      goBack(){
        this.$router.push('/contractOrder')
      },
      sure(){
        let that = this;
        if(that.stop_profit == ''){
          this.$toast.center(this.$t('zyzs.qsrzyjg'));
          return false;
        }
        if(that.stop_loss == ''){
          this.$toast.center(this.$t('zyzs.qsrzsjg'));
          return false;
        }
        let params = {
          id: that.id,
          stop_profit: parseFloat(that.stop_profit),
          stop_loss: parseFloat(that.stop_loss)
        }
        this.$ajax.post('/web/editPosition',params).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.$toast.center(resData.message);
                setTimeout(() => {
                  this.$router.push({ path: '/contractOrder', query: { } })
                },1500)
            }else{
                this.$toast.center(resData.message);
                return;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      zyChange(){
        this.isZy = !this.isZy;
        if(!this.isZy){
          this.stop_profit = 0;
          this.stop_loss = 0;
        }else{
          this.stop_profit = this.price;
          this.stop_loss = this.price;
        }
      },
      numZy(id){
         if(id < 0){
          if(parseFloat(this.stop_profit) > parseFloat(this.price)){
            this.stop_profit = (parseFloat(this.stop_profit) - 1).toFixed(4)
          }
         }else{
           this.stop_profit = (parseFloat(this.stop_profit) + 1).toFixed(4)
         }
       },
       numZs(id){
         if(id < 0){
           if(parseFloat(this.stop_loss) > 1){
            this.stop_loss = (parseFloat(this.stop_loss) - 1).toFixed(4)
           }
           if(this.stop_loss <= 0) this.stop_loss = 0;
         }else{
           if(this.stop_loss < this.price){
             this.stop_loss = (parseFloat(this.stop_loss) + 1).toFixed(4)
           }
         }
       },
       keyMoneyZy(){
        this.stop_profit = this.stop_profit.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.stop_profit = this.stop_profit.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.stop_profit = this.stop_profit.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.stop_profit = this.stop_profit.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.stop_profit.indexOf(".") < 0 && this.stop_profit != "") { //首位是0的话去掉
            this.stop_profit = parseFloat(this.stop_profit);
        }
      },
      keyMoneyZs(){
        this.stop_loss = this.stop_loss.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.stop_loss = this.stop_loss.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.stop_loss = this.stop_loss.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.stop_loss = this.stop_loss.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.stop_loss.indexOf(".") < 0 && this.stop_loss != "") { //首位是0的话去掉
            this.stop_loss = parseFloat(this.stop_loss);
        }
      },
    },
    filters:{

    },
    watch: {

    },
    beforeDestroy(){

    },
    destroyed() {

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        font-size: .56rem;
        line-height: 1.6rem;
        background: #fff;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        transform: translateY(-50%);
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        top: 1.7rem;
        bottom: 4.5rem;
        width: 100%;
        overflow-y: scroll;
    }
    .item-box1{
      padding: 1rem .42rem .4rem;
    }
    .item-box1 .title{
      color: #000;
      font-size: .48rem;
    }
    .item-box1 .buy{
      display: inline-block;
      margin: 0 .16rem 0 .3rem;
      padding: .14rem .2rem;
      color: #2d66cf;
      font-size: .34rem;
      background-color: #ffe4e9;
	    border-radius: 0.1rem;
    }
    .item-box1 .buy.sell{
      color: #cb4040;
    }
    .item-box1 .gg{
      display: inline-block;
      margin-right: .16rem;
      padding: .14rem .32rem;
      color: #2d66cf;
      font-size: .34rem;
      background-color: #dfeaff;
	    border-radius: 0.1rem;
    }
    .item-box1 .num{
      color: #878789;
      font-size: .34rem;
    }
    .item-box1 .item-head{
      position: relative;
    }
    .item-box1 .item-head .cc{
      position: absolute;
      top: 0;
      right: 0;
      padding: .12rem .3rem;
      color: #fff;
      font-size: .36rem;
      background-color: #2d66cf;
	    border-radius: 0.05rem;
    }
    .item-box1 .ul-box{
      display: flex;
      align-items: stretch;
      margin-top: .78rem;
    }
    .item-box1 .ul-box .li{
      margin-right: 1.5rem;
      text-align: center;
    }
    .item-box1 .ul-box .li:last-child{
      margin-right: 0;
    }
    .item-box1 .ul-box .li .t1{
      color: #000;
      font-size: .4rem;
    }
    .item-box1 .ul-box .li .t1.price{
      color: #00a94c;
    }
    .item-box1 .ul-box .li .t2{
      padding-top: .35rem;
      color: #909090;
      font-size: .34rem;
    }
    .item-box1 .stop-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: .85rem;
      padding: .4rem .5rem;
      border-radius: .3rem;
      background: #f9f9f9;
    }
    .item-box1 .stop-box .text{
      color: #000;
      font-size: .42rem;
    }
    .item-box1 .stop-box .arrow{
      width: .42rem;
    }
    .item-box1 .dan{
      position: relative;
      display: inline-block;
      padding: 0 .15rem 0 .3rem;
      color: #2d66cf;
      font-size: .48rem;
    }
    .item-box1 .dan::after{
      position: absolute;
      right: -.15rem;
      top: 50%;
      content: '';
      width: .28rem;
      height: .2rem;
      background: url(../assets/new/sanjiao.png) no-repeat center center;
      background-size: cover;
      transform: translateY(-50%);
    }
    .num-wrap .num-li{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .45rem 0 .5rem;
      border-bottom: 1px solid #f0f0f0;
    }
    .num-wrap .num-li .img2{
      width: 1.25rem;
    }
    .num-wrap .num-li:last-child{
      border-bottom: none;
    }
    .num-wrap .num-li .num-lt .t1{
      color: #000;
      font-size: .38rem;
    }
    .num-wrap .num-li .num-lt .t2{
      padding-top: .3rem;
      color: #a7a7a7;
      font-size: .34rem;
    }
    .num-wrap .num-li .num-rt{
      display: flex;
      align-items: center;
    }
    .num-wrap .num-li .input{
      width: 2.7rem;
      height: .82rem;
      color: #000;
      margin: 0 .2rem;
      font-size: .42rem;
      border: 1px solid #e4e4e4;
      background: #f4f4f4;
      text-align: center;
    }
    .num-wrap .num-li .num-rt .icon{
      width: .36rem;
      height: .36rem;
    }
    .num-wrap .num-li .num-rt2{
      display: block;
      text-align: center;
    }
    .num-wrap .num-li .num-lt .img{
      width: 1.25rem;
      margin-top: .3rem;
    }
    .num-wrap .num-li .num-rt .text{
      padding-bottom: .36rem;
      color: #cdcdcd;
      font-size: .3rem;
    }
    .num-wrap .num-li .num-rt2 .num-box{
      display: flex;
      align-items: center;
    }
    .gg-wrap{
      padding: 0 .4rem;
    }
    .gg-wrap .gg-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .65rem 0 .85rem;
      color: #000;
    }
    .gg-wrap .gg-box .text{
      font-size: .38rem;
    }
    .gg-wrap .gg-box .select{
      display: flex;
      align-items: center;
      font-size: .4rem;
    }
    .gg-wrap .gg-box .select .arrow{
      width: .42rem;
      padding-left: .15rem;
    }
    .btn-box{
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 1.32rem .4rem;
      background: #f3f4f6;
      box-sizing: border-box;
      text-align: center;
    }
    .btn-box .btn{
      background: #0060ff;
    }
    .btn-box .t1{
      color: #6c6c6c;
      font-size: .34rem;
    }
    .btn-box .t2{
      padding: .45rem 0 .75rem;
    }
    .btn-box .money{
      color: #000;
    }
    .alert-select-box{
      position: absolute;
      bottom: 0;
      z-index: 1000;
      width: 100%;
      padding: 0 .62rem .84rem;
      border-radius: .4rem .4rem 0 0;
      background: #fff;
      box-sizing: border-box;
    }
    .alert-select-box .title{
      position: relative;
      margin-bottom: .2rem;
      padding: .74rem 0;
      text-align: center;
    }
    .alert-select-box .title .title-head{
      display: flex;
      justify-content: center;
      align-items: center;
      color: #1cb460;
      font-size: .56rem;
    }
    .alert-select-box .title .title-head .icon{
      width: .68rem;
      margin-right: .36rem;
    }
    .alert-select-box .close{
      position: absolute;
      right: 0;
      top: 50%;
      width: .72rem;
      transform: translateY(-50%);
    }
    .alert-select-box .select{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: .68rem;
    }
    .alert-select-box .select .t1{
      color: #646464;
      font-size: .38rem;
    }
    .alert-select-box .select .t2{
      color: #000;
      font-size: .38rem;
    }
    .alert-select-box .select .t2 .arrow{
      width: .42rem;
    }
    .alert-select-box .bei{
      display: inline-block;
      margin-left: .26rem;
      padding: .16rem .26rem;
      color: #2d66cf;
      font-size: .34rem;
      background: #dfeaff;
	    border-radius: 0.1rem;
    }
    .alert-select-box .btn{
      margin-top: .9rem;
    }
    .alert-select-box2{
      position: absolute;
      bottom: 0;
      z-index: 1000;
      width: 100%;
      padding: 0 .62rem .84rem;
      border-radius: .4rem .4rem 0 0;
      background: #fff;
      box-sizing: border-box;
    }
    .alert-select-box2 .title{
      position: relative;
      margin-bottom: .96rem;
      padding: .74rem 0;
      color: #000;
      font-size: .56rem;
      text-align: center;
    }
    .alert-select-box2 .close{
      position: absolute;
      right: 0;
      top: 50%;
      width: .72rem;
      transform: translateY(-50%);
    }
    .alert-select-box2 .select-ul{
      max-height: 300px;
      overflow-y: scroll;
    }
    .alert-select-box2 .select-ul .select{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: .64rem;
      padding: .42rem .56rem;
      border-radius: .2rem;
      background: #f3f5fa;
    }
    .alert-select-box2 .select-ul .select-left{
      display: flex;
      align-items: center;
    }
    .alert-select-box2 .select-ul .icon{
      width: .96rem;
    }
    .alert-select-box2 .select-ul .coin{
      padding-left: .48rem;
      color: #000;
      font-size: .48rem;
    }
    .alert-select-box2 .arrow{
      width: .58rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/setProfit.vue